// extracted by mini-css-extract-plugin
export default {"createUserButton":"BackOffice_createUserButton__ofu74","container":"BackOffice_container__xVt+t"};